<template>
  <div class="content"> 
	<app-header></app-header>   
	<div class="preview">
		<p class="clearfix panTitle">
			<span @click="changeRead('')" :class="{actived:queryType === '',fl:true}">全部({{allNoRead}})</span>
			<span @click="changeRead(1)" :class="{actived:queryType === 1,fl:true}">未读({{noRead}})</span>
			<span @click="changeRead(2)" :class="{actived:queryType === 2,fl:true}">已读({{read}})</span>
		</p>
		<div class="preContent clearfix">
			<div class="preList fl" @click="resumedetail(items)" v-for = "items in resumeList"  :key="items.id">
				<p class="timerRead clearfix"><span class="timer">{{items.recruitCrateTime}}</span>
				<span v-show = "items.isLook == 2" class="fr">已读</span>
				<i class="fr" v-show = "items.isLook == 1">未读</i></p>
				<div class="prePeople clearfix">
					<div class="preLogo fl">
						<img v-show="items.photo == ''" v-bind:src="avatarPhoto" alt="科研人才网-高校教师博士教辅岗位人才招聘" />
						<img v-show="items.photo != ''" :src="items.image" alt="科研人才网-医药卫生硕士博士科研人才招聘" />
					</div>
					<div class="basics fl">
						<h3>{{items.name}}</h3>
						<p>出生日期:{{items.birth}}</p>
						<p>{{items.school}} | {{items.education}} | {{items.sex|fSex}}</p>
						<p class="skill">技能与证书:{{items.skillsCertificate}}</p>
					</div>
				</div>
			</div>
		</div>
		<div v-if="all > 1" class="page-bar">
			<ul class="clearfix">
					<li v-if="cur==1"><a class="banclick">首页</a></li>
					<li v-if="cur > 1"><a v-on:click="firstClick()">首页</a></li>
				<li v-if="cur>1"><a v-on:click="cur--,pageClick()">上一页</a></li>
				<li v-if="cur==1"><a class="banclick">上一页</a></li>
				<li v-for="index in indexs"  v-bind:class="{ 'active': cur == index}" :key="index.id">
					<a v-on:click="btnClick(index)">{{ index }}</a>
				</li>
				<li v-if="cur!=all"><a v-on:click="cur++,pageClick()">下一页</a></li>
				<li v-if="cur == all"><a class="banclick">下一页</a></li>
				<li  v-if="cur!=all"><a v-on:click="endClick()">尾页</a></li>
				<li v-if="cur == all"><a class="banclick">尾页</a></li>
				<li><a>共<i>{{all}}</i>页</a></li>
			</ul>
		</div>
	</div>
	<app-footer style="position:absolute;bottom:0;width:100%"></app-footer>
  </div>
</template>




<script> 
import AppFooter from '../../components/common/footer.vue'
import AppHeader from '../../components/common/header1.vue'
import {get, postWithJson, form} from '@/api/services'
export default {
  name: 'preview',
  components: {AppFooter,AppHeader },
    data () {
    	return {
	        all: 1, //总页数
	        cur: 1,//当前页码
			companyId:'',
			jobId:'',
			allNoRead:'',//总投递
			noRead:'',//未读
			read:'',//已读
			queryType:'',//全部默认为“”未读0 已读1
			resumeList:'',//简历列表
			// avatarPhoto:'',//上传头像地址
			avatarPhoto:require("../../assets/imgs/personAvatar.png"),//上传头像地址
    	}
  	},
    created:function () {
	    // this.$emit('header', true);
	    // this.$emit('footer', true);
	},

	methods:{
  		getResumelist:function(){
			let _self = this;
			let userCoookie = this.getCookie("session_token");
			if(userCoookie == null || userCoookie == ""){
				this.$router.push({ path:'/login',query:{loginFlag:false}});
				return false;
			}
			if(!_self.$route.query.jobId){
				this.$router.push({ path:'/login'})
				_self.$message({
					message: "请重新登陆！",
					type: 'error'
				}); 
				// _self.$message.error("请重新登陆！"); 
				return false;
			}
  			postWithJson('front/userRecruit/queryUserRecruit?pageNum='+_self.cur+'& pageSize=9',{recruitId:_self.$route.query.jobId,isLook:_self.queryType}).then(
				function(response) {
					if( _self.queryType == ""){
						_self.allNoRead = response.data.total;
						_self.noRead = response.data.notLoockNum;
						_self.read = response.data.loockNum;
					}
					if(response.data.rows.length > 0){
						_self.resumeList = response.data.rows;
						_self.all = parseInt(response.data.total/9);
					}else{
						_self.resumeList = [];
					}
				},
				function(response) {
					_self.$message({
							message: response.data.message,
							type: 'error'
						});          
				}
			)
		},
		getRead(){
			let _self = this;
			postWithJson('front/userRecruit/updateUserRecruit',{id:_self.$route.query.jobId,isLook:1}).then(
				function(response) {
					if(response.data.rows.length > 0){
						
					}
				},
				function(response) {
					_self.$message({
							message: response.data.message,
							type: 'error'
						});          
				}
			)
		},
		changeRead:function(flags){


			let _self = this;
			_self.queryType = flags;
			_self.getResumelist();
		},
		resumedetail:function(items){
			this.$router.push({
				path:'/positionsDetail',
				query:{userId:items.userId,id:items.id}
			});
		},
		firstClick:function(){
			this.cur = 1;
			this.getResumelist();
		},
		checkView:function(flags){
			this.checkViewFlags = flags;
		},
		btnClick: function(data){//页码点击事件
		    if(data != this.cur){
		        this.cur = data;
		        this.getResumelist();
		    }
		},
		pageClick: function(){
			this.getResumelist();
		},
		endClick:function(){
			this.cur = this.all; 
			this.getResumelist();
		}
	},
	mounted:function(){
		this.getResumelist();
		// this.getSumeRead();	
		// this.getRead();
	},
	filters:{
		fSex(val){
			return val == '1'?"男":"女"
		}
	},
	computed: {
		/*this.subjectList();*/
		indexs: function(){
		  var left = 1;
		  var right = this.all;
		  var ar = [];
		  if(this.all>= 5){
			if(this.cur > 3 && this.cur < this.all-2){
					left = this.cur - 2
					right = this.cur + 2
			}else{
				if(this.cur<=3){
					left = 1
					right = 5
				}else{
					right = this.all
					left = this.all -4
				}
			}
		  }
			while (left <= right){
				ar.push(left)
				left ++
			}
			return ar
		}
			 
	},
	
}
</script>

<style  lang = "less"  scoped="scoped">
//滚动条
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #f1f1f1;
}

//滚动条轨道 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #f1f1f1;
    -moz-box-shadow: inset 0 0 6px #f1f1f1;
    box-shadow: inset 0 0 6px #f1f1f1;
    background-color: #f1f1f1;
}

//滑块
::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px #c1c1c1;
    -moz-box-shadow: inset 0 0 6px #c1c1c1;
    box-shadow: inset 0 0 6px #c1c1c1;
    border-radius: 3px;
    background-color: #c1c1c1;
}
.page-bar{
    margin:40px 0;
}
.page-bar ul{
	text-align: center;
}
.page-bar ul,li{
    margin: 0px;
    padding: 0px;
}
.page-bar li{
		display: inline-block;
    list-style: none;
    margin: 0 4px;
}
.page-bar li:first-child>a {
   margin-left: 0px
}
.page-bar a{
    border: 1px solid #ddd;
    text-decoration: none;
    position: relative;
    float: left;
    padding: 6px 12px;
    margin-left: -1px;
    line-height: 1.42857143;
    color: #848484;
    cursor: pointer
}
.page-bar a:hover{
    background-color: #eee;
}
.page-bar a.banclick{
    cursor:not-allowed;
}
.page-bar .active a{
    color: #fff;
    cursor: default;
    background-color: #1787FB;
    border-color: #1787FB;
}
.page-bar i{
    font-style:normal;
    color: #1787FB;
    margin: 0px 4px;
    font-size: 12px;
}
.content{
	width: 100%;
	min-height: 870px;
	position: relative;
	background-color: #F4F8FF;		
	.preview{
		width: 1200px;
		margin: 0 auto;
		.panTitle{
			width: 482px;
			height: 46px;
			line-height: 46px;
			margin: 44px auto;
			border: 1px solid #d4dae4;
			span{
				display: inline-block;
				width: 160px;
				text-align: center;
				border-right: 1px solid #d4dae4;
				box-sizing: border-box;
				cursor: pointer;
			}
			span:last-child{
				border: none;
			}
			.actived{
				background-color: #1787FB;
				color: white;
			}
		}
		.preList{
			width: 386px;
			height: 200px;
			cursor: pointer;
			border: 1px solid #d4dae4;
			margin-right: 14px;
			margin-bottom: 20px;
			box-sizing: border-box;
			.timerRead{
				height: 34px;
				line-height: 34px;
				background-color: #fafafa;
				padding: 0 10px;
				font-size: 14px;
				.timer{					
					color: #878787;
				}
				i{
					color: #1787FB;
					font-style: normal;
				}
			}
			.prePeople{
				padding: 20px;	
				background-color: #fff;			
				.preLogo{
					width: 100px;
					height: 100px;
					margin-right: 20px;
					border-radius: 50%;
					img{
						width: 100px;
						height: 100px;
						border-radius: 50%;
					}
				}
				.basics{
					vertical-align: middle;
					width: 220px;
					img{
						vertical-align: middle;
					}
					.icon{
						display: inline-block;
						width: 25px;
						text-align: center;
						height: 25px;
						line-height: 25px;
						margin-left: 4px;
						color: white;
						border-radius: 4px;
					}
					.boy{
						background-color: #7ca0f5;
					}
					.girl{
						background-color: #1787FB;
					}
					p{
						font-size: 14px;
						color: #444;
						line-height: 24px;
					}
					.skill{
						display: -webkit-box;
						-webkit-line-clamp:2;
						overflow: hidden;
						text-overflow: ellipsis;
						-webkit-box-orient: vertical;
					}
				}
			}
		}
		.preList:hover{
			box-shadow: 6px 6px 10px #aaa;
			transform: translateY(-1px);
		}
	}
	
			
}

</style>



// WEBPACK FOOTER //
// src/views/companyRegister/preview.vue